module.exports = __webpack_public_path__ + "img/reverse_icon.09460a5a.png";